export default "__VITE_ASSET__a00c8748__"